<template>
  <div v-show="loading"> 
 	  <el-skeleton :rows="10" animated />
  </div>


  <div :class="widgetClasses" class="card" v-if="isAllowedFifthPairOption">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder fs-3 mb-1">5th Pair Option</span>
      </h3>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body py-3" >
        <form class="form-horizontal">
          <select v-model="pr_5th" v-on:change="saveFifthPairOptionFN()" class="form-control m-l-39 dashboardFontStyle" style="width:400px;">
            <option value="GC">Product Rewards</option>
            <option value="TV">PGI Rewards</option>
          </select>
        </form>
    </div>
  </div>




  <!--begin::Tables Widget 11-->
  <div :class="widgetClasses" class="card" v-show="!loading">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder fs-3 mb-1">Transaction History</span>
      </h3>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body py-3">
      <!--begin::Table container-->
      <div class="table-responsive">
        <!--begin::Table-->
        <table class="table align-middle gs-0 gy-4">
          <!--begin::Table head-->
          <thead>
            <tr class="fw-bolder text-muted bg-light">
              <th class="ps-4 min-w-125px rounded-start">Ref. #</th>
              <th class="min-w-225px">Date</th>
              <th class="min-w-225px">Reference</th>
              <th class="min-w-300px">Description</th>
              <th class="min-w-150px rounded-end">Amount</th>
            </tr>
          </thead>
          <!--end::Table head-->
          <!--begin::Table body-->
          <tbody>
            <template v-for="(item, index) in list" :key="index">
              <tr>
                <td>&nbsp;&nbsp;&nbsp;{{item.transactionID}}</td>
                <td>{{item.txndte}}</td>
                <td>{{item.rusid}}</td>
                <td>{{item.transactiondesc}}</td>
                <td>{{numberWithCommas(item.txnamount)}}</td>
              </tr>
            </template> 
          </tbody>
          <!--end::Table body-->
        </table>
        <!--end::Table-->
      </div>
      <!--end::Table container-->
    </div>
    <!--begin::Body-->
  </div>
  <!--end::Tables Widget 11-->
</template>

<script lang="ts">
import { defineComponent } from "vue";
import {transactionhistory, getFifthPairOptionDetails, saveFifthPairOption}  from "@/api/transaction";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default defineComponent({
  name: "kt-widget-11", 
  methods: {
    async transactionhistory(){ 
      this.loading = true;
      const response = await transactionhistory(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
    async getFifthPairOptionDetailsFN(){
      const response = await getFifthPairOptionDetails();
      this.pr_5th = response.data.fifthPairLastOption;
      this.isAllowedFifthPairOption = response.data.isAllowedFifthPairOption;
    },

    async saveFifthPairOptionFN(){
      var params = {"pr_5th" : this.pr_5th}
      const response = await saveFifthPairOption(params);
       if(response != null){
          this.loading = false;
          if (response.data.result == "SUCCESS") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
              confirmButtonClass: "btn btn-secondary"
            }); 
           // window.location.reload();
            return; 
          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
            return; 
          }
        }
      
    }

  },
  mounted(){
      this.transactionhistory();
      this.getFifthPairOptionDetailsFN();
  },
  data(){
      return { 
        list : [],
        loading: true,
        pr_5th : "GC",
        isAllowedFifthPairOption : false,
      }
  },
  components: {},
  props: {
    widgetClasses: String
  }
});
</script>
